module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-198.9bcd6461.svg";